import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaShieldAlt, FaChartLine, FaCalendarAlt, FaGlobe, FaCreditCard, FaMobile, FaDiamond, FaUsers, FaChevronDown, FaExchangeAlt } from 'react-icons/fa';
import apptrading from '../assets/trading/apptrading.png';
import advancedAnalysis from '../assets/trading/advanced-analysis.webp';
import botTrader from '../assets/trading/bot-trader.webp';
import wealthImage from '../assets/portfolio/2150769939.jpg';

const BuyCryptoPage = () => {
  const [selectedCrypto, setSelectedCrypto] = useState('BTC');
  const [amount, setAmount] = useState('10000');
  const [convertedAmount, setConvertedAmount] = useState('0');
  const [cryptoData, setCryptoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [cryptoPrices, setCryptoPrices] = useState({});

  const refreshCryptoData = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,ripple,cardano,solana,polkadot,usd-coin,avalanche-2,matic-network,chainlink&vs_currencies=usd&include_24hr_change=true');
      const data = await response.json();
      
      // Store prices for converter
      setCryptoPrices(data);
      
      const liveCryptoData = [
        { symbol: 'BTC', name: 'Bitcoin', price: `$${data.bitcoin?.usd?.toLocaleString() || '66,000'}`, change: `${data.bitcoin?.usd_24h_change ? (data.bitcoin.usd_24h_change > 0 ? '+' : '') + data.bitcoin.usd_24h_change.toFixed(2) : '0.50'}%`, icon: '₿', color: 'text-orange-500', bgColor: 'bg-orange-50', coinId: 'bitcoin' },
        { symbol: 'ETH', name: 'Ethereum', price: `$${data.ethereum?.usd?.toLocaleString() || '3,400'}`, change: `${data.ethereum?.usd_24h_change ? (data.ethereum.usd_24h_change > 0 ? '+' : '') + data.ethereum.usd_24h_change.toFixed(2) : '0.25'}%`, icon: 'Ξ', color: 'text-blue-500', bgColor: 'bg-blue-50', coinId: 'ethereum' },
        { symbol: 'XRP', name: 'XRP', price: `$${data.ripple?.usd?.toFixed(4) || '0.5000'}`, change: `${data.ripple?.usd_24h_change ? (data.ripple.usd_24h_change > 0 ? '+' : '') + data.ripple.usd_24h_change.toFixed(2) : '-0.15'}%`, icon: '✕', color: 'text-black', bgColor: 'bg-gray-50', coinId: 'ripple' },
        { symbol: 'ADA', name: 'Cardano', price: `$${data.cardano?.usd?.toFixed(4) || '0.4500'}`, change: `${data.cardano?.usd_24h_change ? (data.cardano.usd_24h_change > 0 ? '+' : '') + data.cardano.usd_24h_change.toFixed(2) : '0.30'}%`, icon: '₳', color: 'text-blue-600', bgColor: 'bg-blue-50', coinId: 'cardano' },
        { symbol: 'SOL', name: 'Solana', price: `$${data.solana?.usd?.toLocaleString() || '150'}`, change: `${data.solana?.usd_24h_change ? (data.solana.usd_24h_change > 0 ? '+' : '') + data.solana.usd_24h_change.toFixed(2) : '0.40'}%`, icon: '◎', color: 'text-purple-500', bgColor: 'bg-purple-50', coinId: 'solana' },
        { symbol: 'DOT', name: 'Polkadot', price: `$${data.polkadot?.usd?.toFixed(2) || '7.20'}`, change: `${data.polkadot?.usd_24h_change ? (data.polkadot.usd_24h_change > 0 ? '+' : '') + data.polkadot.usd_24h_change.toFixed(2) : '0.20'}%`, icon: '●', color: 'text-pink-500', bgColor: 'bg-pink-50', coinId: 'polkadot' },
        { symbol: 'USDC', name: 'USD Coin', price: `$${data['usd-coin']?.usd?.toFixed(2) || '1.00'}`, change: `${data['usd-coin']?.usd_24h_change ? (data['usd-coin'].usd_24h_change > 0 ? '+' : '') + data['usd-coin'].usd_24h_change.toFixed(2) : '0.00'}%`, icon: '💲', color: 'text-green-500', bgColor: 'bg-green-50', coinId: 'usd-coin' },
        { symbol: 'AVAX', name: 'Avalanche', price: `$${data['avalanche-2']?.usd?.toFixed(2) || '35.00'}`, change: `${data['avalanche-2']?.usd_24h_change ? (data['avalanche-2'].usd_24h_change > 0 ? '+' : '') + data['avalanche-2'].usd_24h_change.toFixed(2) : '0.60'}%`, icon: '❄', color: 'text-red-500', bgColor: 'bg-red-50', coinId: 'avalanche-2' },
        { symbol: 'MATIC', name: 'Polygon', price: `$${data['matic-network']?.usd?.toFixed(4) || '0.8500'}`, change: `${data['matic-network']?.usd_24h_change ? (data['matic-network'].usd_24h_change > 0 ? '+' : '') + data['matic-network'].usd_24h_change.toFixed(2) : '0.35'}%`, icon: '🔷', color: 'text-purple-600', bgColor: 'bg-purple-50', coinId: 'matic-network' },
        { symbol: 'LINK', name: 'Chainlink', price: `$${data.chainlink?.usd?.toFixed(2) || '18.50'}`, change: `${data.chainlink?.usd_24h_change ? (data.chainlink.usd_24h_change > 0 ? '+' : '') + data.chainlink.usd_24h_change.toFixed(2) : '0.45'}%`, icon: '🔗', color: 'text-blue-400', bgColor: 'bg-blue-50', coinId: 'chainlink' }
      ];
      
      setCryptoData(liveCryptoData);
      setLastUpdated(new Date());
      setLoading(false);
    } catch (error) {
      console.error('Error refreshing crypto data:', error);
      setLoading(false);
    }
  };

  // Load crypto data once on mount
  useEffect(() => {
    refreshCryptoData();
  }, []);

  // Update converted amount when amount or selected crypto changes
  useEffect(() => {
    // Only proceed if we have crypto data and prices
    if (cryptoData.length === 0 || Object.keys(cryptoPrices).length === 0) {
      return;
    }
    
    // Find the crypto data for the selected symbol to get the coinId
    const selectedCryptoData = cryptoData.find(c => c.symbol === selectedCrypto);
    if (selectedCryptoData?.coinId && cryptoPrices[selectedCryptoData.coinId]?.usd) {
      const price = cryptoPrices[selectedCryptoData.coinId].usd;
      const converted = (parseFloat(amount) / price).toFixed(6);
      setConvertedAmount(converted);
    }
  }, [amount, selectedCrypto, cryptoPrices, cryptoData]);


  const features = [
    {
      icon: <FaShieldAlt className="text-2xl text-green-600" />,
      title: "Secure and insured assets",
      description: "Your crypto assets are protected with industry-leading security and insurance coverage."
    },
    {
      icon: <FaChartLine className="text-2xl text-green-600" />,
      title: "Earn daily interest",
      description: "Earn up to 16% annual interest on your crypto and fiat assets."
    },
    {
      icon: <FaCalendarAlt className="text-2xl text-green-600" />,
      title: "Instant crypto loans",
      description: "Borrow funds instantly against your crypto assets without selling them."
    }
  ];

  const recurringBuyFeatures = [
    {
      icon: "₿",
      title: "Grow consistently",
      description: "Automate your crypto purchases and grow your portfolio over time."
    },
    {
      icon: "T",
      title: "Dollar-cost average",
      description: "Reduce volatility and mitigate risk by investing a fixed amount regularly."
    },
    {
      icon: "⏰",
      title: "Save time",
      description: "Set up once and let your investments grow automatically."
    }
  ];

  const paymentMethods = [
    { icon: <FaGlobe className="text-xl" />, name: "SEPA", description: "Instant and free bank transfers." },
    { icon: <FaGlobe className="text-xl" />, name: "SWIFT", description: "Global bank transfers." },
    { icon: <FaCreditCard className="text-xl" />, name: "Visa & Mastercard", description: "Instant purchases with your card." },
    { icon: <FaMobile className="text-xl" />, name: "Apple Pay & Google Pay", description: "Secure and fast payments." }
  ];

  const faqs = [
    "How to buy crypto with a card?",
    "How to earn crypto cashback on your purchase?",
    "How to make a bank transfer?",
    "How to add crypto to a SEGWAY CAPITAL wallet?",
    "How to transfer crypto between SEGWAY CAPITAL clients?"
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-6"
            >
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Expand your portfolio with cryptocurrencies
              </h1>
              <p className="text-xl text-gray-600">
                Buy, sell, and earn on over 60 digital assets with SEGWAY CAPITAL's secure platform.
              </p>
              <button className="bg-gray-900 text-white px-8 py-4 rounded-lg hover:bg-gray-800 transition-all duration-300 flex items-center space-x-2 group">
                <span>Top up</span>
                <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
              </button>
              <p className="text-sm text-gray-500 max-w-md">
                A crypto-backed loan is a loan secured by crypto assets. It allows you to borrow funds without selling your crypto.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <img 
                src={apptrading} 
                alt="SEGWAY CAPITAL Trading App" 
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Crypto Converter Section */}
      <section className="py-20 bg-gray-50">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
                Crypto converter
              </h2>
              <p className="text-xl text-gray-600">
                Convert and exchange over 100 digital assets instantly.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-2xl shadow-lg"
            >
              <div className="space-y-6">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Amount in USD</label>
                  <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                    <span className="text-2xl font-bold">${amount}</span>
                    <input
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="text-right bg-transparent border-none outline-none text-2xl font-bold w-32"
                      placeholder="10000"
                    />
                  </div>
                </div>
                
                <div className="flex items-center justify-center">
                  <FaExchangeAlt className="text-gray-400 text-xl" />
                </div>
                
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Select Cryptocurrency</label>
                  <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                      <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center">
                      <img 
                        src={`https://assets.coincap.io/assets/icons/${cryptoData.find(c => c.symbol === selectedCrypto)?.coinId || 'bitcoin'}@2x.png`}
                        alt={selectedCrypto}
                        className="w-6 h-6 object-contain"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <span className="text-xl hidden">{cryptoData.find(c => c.symbol === selectedCrypto)?.icon || '₿'}</span>
                    </div>
                    <span className="text-xl font-semibold">{selectedCrypto}</span>
                  </div>
                    <select
                      value={selectedCrypto}
                      onChange={(e) => setSelectedCrypto(e.target.value)}
                      className="bg-transparent border-none outline-none text-xl font-semibold cursor-pointer"
                    >
                      {cryptoData.map((crypto) => (
                        <option key={crypto.symbol} value={crypto.symbol}>
                          {crypto.symbol} - {crypto.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">You will receive</label>
                  <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg bg-gray-50">
                                      <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center">
                      <img 
                        src={`https://assets.coincap.io/assets/icons/${cryptoData.find(c => c.symbol === selectedCrypto)?.coinId || 'bitcoin'}@2x.png`}
                        alt={selectedCrypto}
                        className="w-6 h-6 object-contain"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <span className="text-xl hidden">{cryptoData.find(c => c.symbol === selectedCrypto)?.icon || '₿'}</span>
                    </div>
                    <span className="text-xl font-semibold">{convertedAmount}</span>
                  </div>
                    <span className="text-sm text-gray-500">
                      ≈ ${(parseFloat(convertedAmount) * (cryptoPrices[cryptoData.find(c => c.symbol === selectedCrypto)?.coinId]?.usd || 0)).toFixed(2)}
                    </span>
                  </div>
                </div>
                
                <button className="w-full bg-gray-900 text-white py-3 rounded-lg hover:bg-gray-800 transition-colors">
                  Buy Now
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Crypto Market Section */}
      <section className="py-20 bg-white">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                  Crypto market
                </h2>
                <p className="text-xl text-gray-600">
                  Browse and buy over 60 digital assets
                </p>
              </div>
              <button 
                onClick={refreshCryptoData}
                className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-all duration-300 flex items-center space-x-2"
              >
                <span>Refresh Data</span>
                <div className={`w-4 h-4 border-2 border-white border-t-transparent rounded-full ${loading ? 'animate-spin' : ''}`}></div>
              </button>
            </div>
          </motion.div>
          
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              {cryptoData.map((crypto, index) => (
                <motion.div
                  key={crypto.symbol}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white p-4 rounded-xl border border-gray-200 hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                                  <div className="flex items-center space-x-3 mb-3">
                  <div className={`w-12 h-12 ${crypto.bgColor} rounded-full flex items-center justify-center overflow-hidden`}>
                    <img 
                      src={`https://assets.coincap.io/assets/icons/${crypto.coinId}@2x.png`}
                      alt={crypto.name}
                      className="w-8 h-8 object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <span className={`text-2xl ${crypto.color} hidden`}>{crypto.icon}</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{crypto.symbol}</div>
                    <div className="text-sm text-gray-500">{crypto.name}</div>
                  </div>
                </div>
                  <div className="text-lg font-bold text-gray-900 mb-1">{crypto.price}</div>
                  <div className={`text-sm ${crypto.change.startsWith('+') ? 'text-green-600' : crypto.change.startsWith('-') ? 'text-red-600' : 'text-gray-600'}`}>
                    {crypto.change}
                  </div>
                </motion.div>
              ))}
            </div>
          )}
          
          <div className="text-center mt-8 space-y-4">
            <button className="text-gray-600 hover:text-gray-900 font-medium transition-colors">
              View more
            </button>
            {lastUpdated && (
              <div className="text-sm text-gray-500">
                Last updated: {lastUpdated.toLocaleTimeString()}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Funding Methods Section */}
      <section className="py-20 bg-gray-50">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Fund your account with ease
            </h2>
            <p className="text-xl text-gray-600">
              Multiple payment methods to suit your needs.
            </p>
          </motion.div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {paymentMethods.map((method, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div className="text-gray-600 mb-4 flex justify-center">
                  {method.icon}
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{method.name}</h3>
                <p className="text-gray-600 text-sm">{method.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
                How SEGWAY CAPITAL helps you build your wealth.
              </h2>
              <div className="space-y-6">
                {features.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="flex items-start space-x-4"
                  >
                    <div className="flex-shrink-0 mt-1">
                      {feature.icon}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img 
                src={advancedAnalysis} 
                alt="Advanced Trading Analysis" 
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Recurring Buy Section */}
      <section className="py-20 bg-gray-50">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Build your portfolio with Recurring Buys
            </h2>
          </motion.div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {recurringBuyFeatures.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center p-8 bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Crypto Baskets Section */}
      <section className="py-20 bg-white">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
                Diversify with Crypto Baskets
              </h2>
              <p className="text-xl text-gray-600">
                Invest in a diversified portfolio of cryptocurrencies with a single click.
              </p>
              <button className="bg-gray-900 text-white px-8 py-4 rounded-lg hover:bg-gray-800 transition-all duration-300 flex items-center space-x-2 group">
                <span>Buy a basket</span>
                <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
              </button>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img 
                src={botTrader} 
                alt="Crypto Baskets Trading" 
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Wealth Solutions Section */}
      <section className="py-20 bg-gradient-to-br from-gray-800 to-gray-600">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-6 text-white"
            >
              <h2 className="text-3xl lg:text-4xl font-bold">
                Wealth solutions for private clients.
              </h2>
              <p className="text-xl text-gray-200">
                Access exclusive wealth management services, personalized advice, and tailored solutions for high-net-worth individuals and institutions.
              </p>
              <button className="bg-teal-500 text-white px-8 py-4 rounded-lg hover:bg-teal-600 transition-all duration-300 flex items-center space-x-2 group">
                <span>Learn more</span>
                <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
              </button>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="relative"
            >
              <img 
                src={wealthImage} 
                alt="Wealth Solutions" 
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">
                Frequently asked questions.
              </h2>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="space-y-4"
            >
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="text-gray-900">{faq}</span>
                  <FaChevronDown className="text-gray-400" />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Next Generation Section */}
      <section className="py-20 bg-gradient-to-br from-gray-800 to-gray-600">
        <div className="section-container text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto space-y-6"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-white">
              Driving the next generation of wealth
            </h2>
            <p className="text-xl text-gray-200">
              Leveraging blockchain technology and innovative financial solutions to create sustainable wealth for our clients.
            </p>
            <button className="bg-teal-500 text-white px-8 py-4 rounded-lg hover:bg-teal-600 transition-all duration-300 flex items-center space-x-2 group mx-auto">
              <span>Sign up</span>
              <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default BuyCryptoPage; 